import * as yup from 'yup';

export const addCustomerFormValidator = yup.object().shape({
  email: yup.string().email().required('customer.inviteModal.emailError'),
  firstAppointmentDate: yup.date().required(),
  firstName: yup.string().required('customer.inviteModal.firstNameError'),
  lang: yup.string().required('customer.inviteModal.langError'),
  lastName: yup.string().required('customer.inviteModal.lastNameError'),
});
